<template>
  <div>
    <h1>账户管理</h1>
  </div>
</template>
<script>
export default {
  name: 'AccountSetting',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/setting/Account.vue